var _metadata, _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.84420060904381 38.69917697881709",
    width: 38.84420060904381,
    height: 38.69917697881709,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    className: "style-fonts"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(8.019578493291078 17.687547802962627) rotate(45 11.5 1.6870070601016778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.84 0 C5.26 0, 9.68 0, 22.16 0 C22.72 0, 23 0.28, 23 0.84 C23 1.41, 23 1.97, 23 2.53 C23 3.09, 22.72 3.37, 22.16 3.37 C17.23 3.37, 12.3 3.37, 0.84 3.37 C0.28 3.37, 0 3.09, 0 2.53 C0 1.97, 0 1.41, 0 0.84 C0 0.28, 0.28 0, 0.84 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#005e79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.84 0 C8.24 0, 15.64 0, 22.16 0 M0.84 0 C9.05 0, 17.25 0, 22.16 0 M22.16 0 C22.72 0, 23 0.28, 23 0.84 M22.16 0 C22.72 0, 23 0.28, 23 0.84 M23 0.84 C23 1.27, 23 1.7, 23 2.53 M23 0.84 C23 1.37, 23 1.89, 23 2.53 M23 2.53 C23 3.09, 22.72 3.37, 22.16 3.37 M23 2.53 C23 3.09, 22.72 3.37, 22.16 3.37 M22.16 3.37 C17.06 3.37, 11.97 3.37, 0.84 3.37 M22.16 3.37 C17.12 3.37, 12.08 3.37, 0.84 3.37 M0.84 3.37 C0.28 3.37, 0 3.09, 0 2.53 M0.84 3.37 C0.28 3.37, 0 3.09, 0 2.53 M0 2.53 C0 1.96, 0 1.38, 0 0.84 M0 2.53 C0 2.09, 0 1.65, 0 0.84 M0 0.84 C0 0.28, 0.28 0, 0.84 0 M0 0.84 C0 0.28, 0.28 0, 0.84 0",
    stroke: "#005e79",
    strokeWidth: 2,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(7.824622115752732 17.63761505565111) rotate(315 11.5 1.6870070601016778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.84 0 C7.46 0, 14.08 0, 22.16 0 C22.72 0, 23 0.28, 23 0.84 C23 1.24, 23 1.64, 23 2.53 C23 3.09, 22.72 3.37, 22.16 3.37 C15.17 3.37, 8.18 3.37, 0.84 3.37 C0.28 3.37, 0 3.09, 0 2.53 C0 2.03, 0 1.52, 0 0.84 C0 0.28, 0.28 0, 0.84 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#e0115f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.84 0 C8.16 0, 15.48 0, 22.16 0 M0.84 0 C7.13 0, 13.42 0, 22.16 0 M22.16 0 C22.72 0, 23 0.28, 23 0.84 M22.16 0 C22.72 0, 23 0.28, 23 0.84 M23 0.84 C23 1.41, 23 1.98, 23 2.53 M23 0.84 C23 1.43, 23 2.02, 23 2.53 M23 2.53 C23 3.09, 22.72 3.37, 22.16 3.37 M23 2.53 C23 3.09, 22.72 3.37, 22.16 3.37 M22.16 3.37 C16.91 3.37, 11.66 3.37, 0.84 3.37 M22.16 3.37 C14.8 3.37, 7.45 3.37, 0.84 3.37 M0.84 3.37 C0.28 3.37, 0 3.09, 0 2.53 M0.84 3.37 C0.28 3.37, 0 3.09, 0 2.53 M0 2.53 C0 2.19, 0 1.85, 0 0.84 M0 2.53 C0 1.87, 0 1.21, 0 0.84 M0 0.84 C0 0.28, 0.28 0, 0.84 0 M0 0.84 C0 0.28, 0.28 0, 0.84 0",
    stroke: "#e0115f",
    strokeWidth: 2,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.b959c5882b01ec3ee686761006cc9323.svg";
export { ForwardRef as ReactComponent };